<template lang="pug">
transition(name="fade")
  .SoundSettingOverlay
    .inner
      .description
        | キーボードリルでは効果音やBGMとして音が鳴ります。ご注意ください。<br>
        | (動画部分では音声で説明が入ります。再生前にボリュームをご確認ください。)

      .toggleSwitch
        .toggleSwitch__on(
          @click="handleMuteSettingSwitchClick('effect', false)"
          :class="{ 'toggleSwitch__on--current': isEffectSoundMuted === false }"
        )
          font-awesome-icon.icon(icon="volume-up")
          | 効果音あり
        .toggleSwitch__off(
          @click="handleMuteSettingSwitchClick('effect', true)"
          :class="{ 'toggleSwitch__off--current': isEffectSoundMuted === true }"
          v-menuHoverSound
        )
          font-awesome-icon.icon(icon="volume-mute")
          | 効果音なし

      .toggleSwitch
        .toggleSwitch__on(
          @click="handleMuteSettingSwitchClick('bgm', false)"
          :class="{ 'toggleSwitch__on--current': isBGMSoundMuted === false }"
        )
          font-awesome-icon.icon(icon="volume-up")
          | BGMあり
        .toggleSwitch__off(
          @click="handleMuteSettingSwitchClick('bgm', true)"
          :class="{ 'toggleSwitch__off--current': isBGMSoundMuted === true }"
          v-menuHoverSound
        )
          font-awesome-icon.icon(icon="volume-mute")
          | BGMなし

      km-button(@click="handleStartButtonClick") スタート
</template>

<script>
import { mapState, mapActions } from 'vuex'
import soundService from '@/services/SoundService'

export default {
  name: 'km-sound-setting-overlay',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapState('User', {
      isEffectSoundMuted: state => state.isEffectSoundMuted,
      isBGMSoundMuted: state => state.isBGMSoundMuted
    })
  },
  methods: {
    ...mapActions('User', [
      'setEffectSoundMuteStatus',
      'setBGMSoundMuteStatus'
    ]),
    handleMuteSettingSwitchClick(type, isMuted) {
      switch (type) {
        case 'effect':
          this.setEffectSoundMuteStatus(isMuted)
          soundService.setMute('effect', isMuted)
          break
        case 'bgm':
          this.setBGMSoundMuteStatus(isMuted)
          soundService.setMute('bgm', isMuted)
          break
      }
    },
    handleStartButtonClick() {
      soundService.init({
        isEffectSoundMuted: this.isEffectSoundMuted,
        isBGMSoundMuted: this.isBGMSoundMuted
      })
      this.$emit('onFinished')
    }
  }
}
</script>

<style lang="scss" scoped>
.SoundSettingOverlay {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  align-items: center;
  justify-content: center;
  z-index: 1010;
}

.inner {
  text-align: center;
}

.description {
  margin: 0 0 20px 0;
  color: #fff;
}

.toggleSwitch {
  display: inline-flex;
  margin: 0 10px 40px;
  &__on,
  &__off {
    padding: 10px;
    border: 2px solid rgba(255, 255, 255, 0.25);
    color: #fff;
    transition: ease 0.5s;
    transition-property: border-color, background, color;

    &--current {
      border-color: #fff;
      background: #fff;
      color: #000;
    }
    &:hover {
      border-color: rgba(255, 255, 255, 0.5);
    }
  }
  &__on {
    border-right: 0;
    border-radius: 10px 0 0 10px;
  }
  &__off {
    border-left: 0;
    border-radius: 0 10px 10px 0;
  }
}

.icon {
  margin: 0 10px 0 0;
}
</style>
